export function isIterable(o) {
    return o !== null && typeof o === 'object' && typeof o[Symbol.iterator] === 'function';
}
export default isIterable;
//# sourceMappingURL=isIterable.js.map